export * from './prestacao'
export * from './concursos'
export * from './receitasDespesas'
export * from './consumo'
export * from './remedios'
export * from './emendasParlamentares'
export * from './procedimentosSaude'
export * from './eleicaoConselho'
export * from './movimentosODS'
export * from './planoDeGoverno'



// WEBPACK FOOTER //
// ./src/router/public/index.js